/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

export default function ShowAutoSummary(props)
{
    const [autoSummary, setAutoSummary] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setAutoSummary(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleShowAutoSummary = () => {
        setAutoSummary(!autoSummary);
        props.onChange(!autoSummary)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={autoSummary}
                        onChange={handleShowAutoSummary}
                        name="Show AutoSummary"
                        color="primary"
                        />
                    }
                    label="Show AutoSummary"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Show the AutoSummary Widget">
                        <DescriptionOutlinedIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

